import {URLPAGINA} from "../../Constantes";

export const crearLinkCampana = ({idFunnel, idUsuario}) => {

    let link = URLPAGINA + '?id=' + idFunnel + '&idUsu=' + idUsuario;

    return link


}